/**
 * @flow
 */
import styled from 'react-emotion'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import Colors from '../../../themes/Colors'
import { Typo16WhiteTwoDR } from '../../../themes/Fonts/Din2014'

export const PlayInInternationalStadiumStripSection = styled('div')`
  background: ${Colors.blackDefault};
  background-repeat: no-repeat;
  background-size: cover;
  font-size: 16px;
  @media only screen and (min-width: 320px) and (max-width: 1023px) {
    margin-top: -14px;
    padding-bottom: 3.75em;
  }
`
export const PlayInStripContainer = styled('div')``
export const PlayInInternationalStadiumStripContainer = styled(
  ResponsiveContainer
)`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding-top: 5.375em;
  padding-bottom: 5em;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    padding-top: 3.75em;
    padding-bottom: 0;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    flex-wrap: wrap;
    padding-top: 3.75em;
    padding-bottom: 3.75em;
  }
`
export const PlayInInternationalStadiumInnerContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 1.5625em;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin-right: 3.75em;
    margin-bottom: 2.875em;
  }
  @media only screen and (min-width: 1025px) {
    width: 25%;
  }
`

export const PlayInInternationalStadiumText = styled(Typo16WhiteTwoDR)`
  text-align: center;
  color: ${Colors.whiteTwo};
  margin-top: 1.4375em;
  line-height: normal;
  letter-spacing: normal;
`

export const PlayInInternationalStadiumSvgContainer = styled('span')`
  min-height: 4.0625em;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    min-height: auto;
  }
`
export const MobileContainer = styled('div')`
  ${'' /* position: relative;
  ${'' /* overflow: hidden; */} */}
  @media (min-width: 768px) {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/PlayInInternationalStrip/styledComponents.js